const roleNames = {
  admin: 'administrador',
  doorman: 'Ordenanza',
  analyst: 'Analista',
  contractor: 'Contractor',
  superadmin: 'Superadministrador'
}

export default roleNames;
